import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  path?: string;
}

const SEO = ({ title, description, path }: SEOProps) => {
  useEffect(() => {
    // Determine the base URL for absolute canonical paths
    const baseUrl = 'https://akrlabs.in';
    
    // Update Title
    const fullTitle = `${title} | AKR Labs`;
    document.title = fullTitle;
    
    // Update OG Title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);

    // Update Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    
    // Update OG Description
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);

    // Update Canonical Tag
    if (path !== undefined) {
      const canonicalUrl = `${baseUrl}${path === '/' ? '' : path}`;
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', canonicalUrl);
    }
  }, [title, description, path]);

  return null; // This component does not render any visible UI
};

export default SEO;
